// extracted by mini-css-extract-plugin
export default {"mainReviewsWrapper":"nF-z"};